import {Form} from 'semantic-ui-react';

function FormTextArea(props) {
  const {input, required, label, type, size, meta: {touched, error}} = props;
  const id = props.id || input.name;
  const placeholder = props.placeholder || label;
  const exactLabel = ['.', '?', '!', '؟'].includes(label.charAt(label.length - 1));

  return (
    <Form.Field
      {...input}
      id={id}
      label={exactLabel ? label : `${label} :`}
      required={required}
      control={Form.TextArea}
      placeholder={placeholder}
      type={type}
      size={size}
      error={(touched && error != null) ? error : false}
    />
  );
}

export default FormTextArea;
